export enum Period {
  TODAY = 'today',
  YESTERDAY = 'yesterday',
  CALENDAR_WEEK_END = 'calendarWeekEnd',
  LAST_CALENDAR_WEEK_END = 'lastCalendarWeekEnd',
  CALENDAR_MONTH_END = 'calendarMonthEnd',
  LAST_CALENDAR_MONTH_END = 'lastCalendarMonthEnd',
  CALENDAR_YEAR_END = 'calendarYearEnd',
  LAST_CALENDAR_YEAR_END = 'lastCalendarYearEnd',
  FISCAL_WEEK_END = 'fiscalWeekEnd',
  LAST_FISCAL_WEEK_END = 'lastFiscalWeekEnd',
  FISCAL_MONTH_END = 'fiscalMonthEnd',
  LAST_FISCAL_MONTH_END = 'lastFiscalMonthEnd',
  FISCAL_YEAR_END = 'fiscalYearEnd',
  LAST_FISCAL_YEAR_END = 'lastFiscalYearEnd',
}

export enum Prior {
  PERIOD = 'previousPeriod',
  YEAR = 'priorYear',
}

export enum Same {
  DATE = 'sameDate',
  DAY = 'sameDay',
}

export enum PeriodRange {
  START_DATE = 'startDate',
  END_DATE = 'endDate',
  START_DAY = 'startDay',
  END_DAY = 'endDay',
}

export enum PaymentType {
  ALL = 'all',
  CASH = 'cash',
  CREDIT_DEBIT = 'creditDebit',
  HOUSE_ACCOUNTS = 'houseAccounts',
  OTHER = 'other',
}

export enum PayrollPeriod {
  CALENDAR_DATE = 'calendarDate',
  PAY_PERIOD_START_DATE = 'payPeriodStartDate',
  PAY_PERIOD_END_DATE = 'payPeriodEndDate',
  PAY_PERIOD_START_DATE_SAME_DAY_PRIOR_YEAR = 'payPeriodStartDateSameDayPriorYear',
  PAY_PERIOD_END_DATE_SAME_DAY_PRIOR_YEAR = 'payPeriodEndDateSameDayPriorYear',
  PREVIOUS_PAY_PERIOD_START_DATE = 'previousPayPeriodStartDate',
  PREVIOUS_PAY_PERIOD_END_DATE = 'previousPayPeriodEndDate',
  PREVIOUS_PAY_PERIOD_START_DATE_SAME_DAY_PRIOR_YEAR = 'previousPayPeriodStartDateSameDayPriorYear',
  PREVIOUS_PAY_PERIOD_END_DATE_SAME_DAY_PRIOR_YEAR = 'previousPayPeriodEndDateSameDayPriorYear',
}
